import React from 'react';
import classNames from 'classnames';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons/faThumbsUp';

import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';

import styles from './actionsStyles.scss';

const Like: React.FC<{
  currentUserHasLiked: boolean;
  id: string;
  isLoading?: boolean;
  likeCount: number;
  onClick: () => void;
}> = ({ currentUserHasLiked, id, isLoading, likeCount, onClick }): React.ReactElement => (
  <span className={classNames(styles.feedAction, styles.likeWrapper)}>
    <Button
      analyticsTag="like"
      faIcon={faThumbsUp}
      iconStyle={classNames(styles.likeIcon, { [styles.active]: currentUserHasLiked })}
      id={id}
      isLoading={isLoading}
      onClick={onClick}
      size={BUTTON_SIZES.SMALL}
      className={classNames(styles.likeText, { [styles.active]: currentUserHasLiked })}
      text={`${currentUserHasLiked ? 'Liked' : 'Like'} ${likeCount > 0 ? ` (${likeCount})` : ''}`}
      type={BUTTON_TYPES.LINK}
    />
  </span>
);

export default Like;
